import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainSearch,
    CurrentReservationSearch,
    GuestAlert,
    ReservationStatusCount,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    ComplainSearch_GroupBy,
    FilterTypes,
    AlertType,
    AuthActionCodes,
    JobPopoverMode,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import { GuestLookup, ListResponse } from "../../Models/ResponseModels";
import * as _ from "lodash";
import * as moment from "moment";
import { ComplainService } from "../../Services/ComplainService";
import { GlitchService } from "../../Services/GlitchService";
import {
    TopFilterStatModel,
    SearchTextResult,
} from "../../Models/CommonModels";
import * as alasql from "alasql";
import {
    GenericMaster_String,
    LocationLookup,
    PropertyBasicInfo,
} from "../../Models/GlobalEntities";
import { Observable, of } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    map,
    tap,
    switchMap,
    retry,
} from "rxjs/operators";
import {
    NgbTypeaheadSelectItemEvent,
    NgbModal,
    NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { GuestDetail } from "../GuestDetail/GuestDetail";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { TagStaff } from "../TagStaff/TagStaff";
import { SelectPMSDates } from "../SelectPMSDates/SelectPMSDates";
import {AppSettings} from "../../Library/AppSettings";

@Component({
    selector: "CurrentReservationConsole",
    templateUrl: "./CurrentReservationConsole.html",
})
export class CurrentReservationConsole
    extends BaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild("guestDetail") guestDetail: GuestDetail;
    @ViewChild("tagStaff") tagStaff: TagStaff;
    @ViewChild("guestKey") guestKey;
    @ViewChild("pmsDateFilter") pmsDateFilter: SelectPMSDates;
    @ViewChild("guestSearchPopup") guestSearchPopup: any;
    SelectedGuests: GuestLookup[] = [];

    RequestModel: CurrentReservationSearch;
    Model: ListResponse;

    FilterRequestModel: CurrentReservationSearch =
        new CurrentReservationSearch();

    DateFormat: string;
    PropStatModel: Array<TopFilterStatModel> = [];

    lstLocations: Array<LocationLookup> = [];
    KeywordSearch: string = null;

    SelectedPropertyId: number;

    MasterCache: any = {};

    SelectedReservation: any;

    EnabledFilters: Array<FilterTypes> = [
        FilterTypes.Location,
        FilterTypes.Vip,
        FilterTypes.HasGlitch,
        FilterTypes.TaggedStaffIds,
        FilterTypes.Pax,
        FilterTypes.HasJobs,
        FilterTypes.HasMembership,
    ];

    _AlertType = AlertType;
    lstProperties: Array<PropertyBasicInfo> = [];
    _JobPopoverMode = JobPopoverMode;
    SortParams: Array<GenericMaster_String> = [];
    SortByText: string = "";

    SelectedTab: string = "2";

    SearchOnEntities: Array<EntityCodes> = [
        EntityCodes.Location,
        EntityCodes.Vip,
    ];

    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        public complainService: ComplainService,
        public glitchService: GlitchService,
        protected modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);
        this.complainService.SelectedJob = null;
        this.CreateSortParams();
    }

    ngOnDestroy(): void {
        this.glitchService.SelectedGlitch = null;
    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.FrontOffice
        );
        this.SelectedPropertyId = this.masterService.GetDefaultProperty_Action(
            AuthActionCodes.FrontOffice
        );

        this.InitRequestModel();

        this.PopulateTopFilters();
        this.SetTopStatusData();
        this.SetData();

        this.CreateCache();
    }

    InitRequestModel(propertyId?: number): void {
        this.RequestModel = new CurrentReservationSearch();
        this.FilterRequestModel = new CurrentReservationSearch();
        this.RequestModel.SetDefaults();

        this.SetSearchProperties(propertyId);
    }

    SetSearchProperties(propertyId?: number): void {
        this.RequestModel.PropertyId = propertyId
            ? propertyId
            : this.SelectedPropertyId;
        this.FilterRequestModel.Properties = [];
        this.FilterRequestModel.Properties.push(
            propertyId ? propertyId : this.SelectedPropertyId
        );
    }

    CreateSortParams(): void {
        this.SortParams = [
            { Id: "ArrivalDate asc", Name: "BTN.BTN_ARRIVALDATE_ASC" },
            { Id: "ArrivalDate desc", Name: "BTN.BTN_ARRIVALDATE_DESC" },
            { Id: "DepartureDate asc", Name: "BTN.BTN_DEPARTUREDATE_ASC" },
            { Id: "DepartureDate desc", Name: "BTN.BTN_DEPARTUREDATE_DESC" },
            { Id: "LocationDescription asc", Name: "BTN.BTN_ROOMNUMBER_ASC" },
            { Id: "LocationDescription desc", Name: "BTN.BTN_ROOMNUMBER_DESC" },
            { Id: "FName asc", Name: "BTN.BTN_FNAME_ASC" },
            { Id: "FName desc", Name: "BTN.BTN_FNAME_DESC" },
            { Id: "LName asc", Name: "BTN.BTN_LNAME_ASC" },
            { Id: "LName desc", Name: "BTN.BTN_LNAME_DESC" },
        ];
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: "fas fa-bars",
            Label: "LBL.ALL",
            Value: 0,
        } as TopFilterStatModel);
        this.PropStatModel.push({
            Id: "1",
            //IconClass: 'fas fa-plane-arrival',
            Label: "LBL.PRE_ARRIVAL",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "2",
            //IconClass: 'fas fa-unlock-alt',
            Label: "LBL.IN_HOUSE",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "8",
            //IconClass: 'fas fa-sign-out-alt',
            Label: "LBL.DUE_OUT",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "3",
            //IconClass: 'fas fa-sign-out-alt',
            Label: "LBL.CHECKED_OUT",
            Value: 0,
        } as TopFilterStatModel);
    }

    FindStatus(Status: string): TopFilterStatModel {
        return this.PropStatModel.find((value) => {
            return value.Id == Status;
        });
    }

    Transform_TopFilter(lst: any): void {
        if (lst == null) return;

        let totalCount = 0;

        for (let i = 0; i < this.PropStatModel.length; i++) {
            let row = this.PropStatModel[i];

            if (row != null && row.Id != null && row.Id != "8") {
                let count = alasql(
                    "Select SUM([Count]) as cnt from ? where ReservationStatus = ?",
                    [lst, parseInt(row.Id)]
                );

                row.Value = count[0].cnt;
                totalCount = totalCount + row.Value;
            }
        }

        this.FindStatus(null).Value = totalCount;
    }

    SetTopStatusData(): void {
        let reqModel: ReservationStatusCount = new ReservationStatusCount();
        reqModel.PropertyId = this.RequestModel.PropertyId;

        this.pmsService
            .CurrentReservations_StatusCounts(reqModel, false)
            .then((data) => {
                this.Transform_TopFilter(data);
                // this.FindStatus('8').Value = 0;
            });

        this.setDueOutRequestObject(reqModel);

        this.pmsService
            .CurrentReservations_StatusCounts(reqModel, false)
            .then((data) => {
                if (data && data.length > 0) {
                    this.FindStatus("8").Value = data[0].Count;
                } else {
                    this.FindStatus("8").Value = 0;
                }
            });
    }

    onTopFilter(StatusCode: string): void {
        //console.info(StatusCode);
        this.RequestModel.ReservationStatus = parseInt(StatusCode);
        this.RequestModel.StartDate = null;
        this.RequestModel.EndDate = null;
        let selectedSortParam;
        switch (StatusCode) {
            case "1":
                selectedSortParam = this.SortParams.find(
                    (a) => a.Id == "ArrivalDate asc"
                );
                this.RequestModel.OrderBy = selectedSortParam.Id;
                this.SortByText = "";
                break;
            case "2":
                selectedSortParam = this.SortParams.find(
                    (a) => a.Id == "LocationDescription asc"
                );
                this.RequestModel.OrderBy = selectedSortParam.Id;
                this.SortByText = "";
                break;
            case "3":
                selectedSortParam = this.SortParams.find(
                    (a) => a.Id == "DepartureDate desc"
                );
                this.RequestModel.OrderBy = selectedSortParam.Id;
                this.SortByText = "";
                break;
            case "8":
                selectedSortParam = this.SortParams.find(
                    (a) => a.Id == "LocationDescription asc"
                );
                this.RequestModel.OrderBy = selectedSortParam.Id;
                this.SortByText = "";
                this.RequestModel.ReservationStatus = 2; // Due Out Case
                this.setDueOutRequestObject(this.RequestModel);
                break;
        }
        this.SelectedTab = StatusCode;
        //this.pmsDateFilter && this.pmsDateFilter.resetSelection();
        this.SetData();
    }

    refreshGridData(): void {
        this.SetTopStatusData();
        this.SetData();
    }

    onPropertyChange(PropertyId: number): void {
        this.RequestModel.PropertyId = PropertyId;
        this.FilterRequestModel.Properties = [];
        this.FilterRequestModel.Properties.push(PropertyId);
        this.SetTopStatusData();

        this.SetData();
    }

    onFilter(row?: GenericMaster_String): void {
        //this.RequestModel.Keyword = this.KeywordSearch;
        this.RequestModel.Locations = this.FilterRequestModel.Locations;
        this.RequestModel.VIPCodes = this.FilterRequestModel.VIPCodes;
        this.RequestModel.HasGlitchRegistered =
            this.FilterRequestModel.HasGlitchRegistered;
        this.RequestModel.TaggedStaffIds =
            this.FilterRequestModel.TaggedStaffIds;
        this.RequestModel.PAX = this.FilterRequestModel.PAX;
        this.RequestModel.HasCallRegistered =
            this.FilterRequestModel.HasCallRegistered;
        this.RequestModel.HasGuestMembership =
            this.FilterRequestModel.HasGuestMembership;

        if (row) {
            this.RequestModel.OrderBy = row.Id;
            this.SortByText = row.Name;
        }
        this.SetData();
    }

    SetData(): void {
        this.onGuestSelected(null);
        this.IsSubmitting = true;
        this.Model = new ListResponse();
        this.Model.Result = [];
        //this.RequestModel.Keyword = this.KeywordSearch;
        Promise.all([
            this.pmsService.GetHKStatusReport(this.RequestModel.PropertyId),
            this.pmsService.CurrentReservations_Search(this.RequestModel, false)
        ]).then((response) => {
                let roomStatusByLocation: any;
                let [hkStatusReportRes, data] = response;
                if (hkStatusReportRes && hkStatusReportRes.Result) {
                roomStatusByLocation = _.keyBy(hkStatusReportRes.Result, "Id");
            }

                this.Model = data;
                let currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                let StartDate = moment.utc(currentDate);
                let utcEndDate = moment.utc(currentDate);
                let EndDate = utcEndDate.add(1, "d");
                let vipList = this.masterService.GetVIPDetails(this.RequestModel.PropertyId);
                let keyByVIPList: any;
                if (vipList) {
                    keyByVIPList = _.keyBy(vipList, 'Code');
            }
            this.Model.Result.forEach((row) => {
                if (row.LocationId) {
                    row['RoomStatus'] = roomStatusByLocation[row.LocationId].RoomStatus;
                }
                    if (vipList && vipList.length && keyByVIPList) {
                        if (row && row.VIPDescription && row.VIP) {
                            if (keyByVIPList[row.VIP] && keyByVIPList[row.VIP].Description) {
                                row.VIPDescription = keyByVIPList[row.VIP].Description;
                            }
                        }
                    }
                    if (row.BirthDay) {
                        let CurrentDate = new Date();
                        CurrentDate.setHours(0, 0, 0, 0);
                        //let c = row.BirthDay.replace(/Z/g, '');
                        let Birthday = new Date(row.BirthDay.replace(/Z/g, ""));
                        Birthday.setHours(0, 0, 0, 0);
                        if (
                            CurrentDate.getMonth() == Birthday.getMonth() &&
                            CurrentDate.getDate() == Birthday.getDate()
                        )
                            row.IsBirthday = true;
                        else row.IsBirthday = false;
                    }
                    if (
                        row.GuestMemberShips &&
                        row.GuestMemberShips.length > 0
                    ) {
                        let memberShipTitle = "";
                        row.GuestMemberShips.forEach((a, index) => {
                            if (a.Level != null) {
                                memberShipTitle += a.Level;
                                if (index < row.GuestMemberShips.length - 1) {
                                    memberShipTitle += ", ";
                                }
                            }
                        });
                        row.GuestMemberShipTitle = memberShipTitle;
                    }
                    if (
                        row.ReservationStatus == 1 ||
                        row.ReservationStatus == 6
                    )
                        row.GuestType = 1;
                    else if (row.ReservationStatus == 3) row.GuestType = 3;
                    else if (row.ReservationStatus == 2) {
                        row.GuestType = 2;
                        if (
                            StartDate.isBefore(row.DepartureDate) &&
                            EndDate.isAfter(row.DepartureDate)
                        ) {
                            row.GuestType = 8;
                        }
                    }
                });
            this.RequestModel.PageNumber = data.CurrentPage;
                this.IsSubmitting = false;
            }).catch((reason) => {
                this.IsSubmitting = false;
            });
    }

    onPageChange(): void {
        this.SetData();
    }

    CreateCache(): void {
        this.MasterCache[EntityCodes.Location] = [];
        this.MasterCache[EntityCodes.Vip] = [];

        let propID = this.RequestModel.PropertyId;

        let objProp =
            this.masterService.Cache_PropertyMainMasters.getValue(propID);

        if (objProp != null) {
            let res: Array<any>;

            this.MasterCache[EntityCodes.Location] = this.MasterCache[
                EntityCodes.Location
            ].concat(objProp.Location);
            this.MasterCache[EntityCodes.Vip] = this.MasterCache[
                EntityCodes.Vip
            ].concat(objProp.VIPs);
        }
    }

    onClearFilter(): void {
        this.InitRequestModel(this.RequestModel.PropertyId);
        this.KeywordSearch = null;
        this.SelectedTab = "2";
        //this.pmsDateFilter && this.pmsDateFilter.resetSelection();
        this.SetData();
    }

    onGuestSelected(data: any): void {
        if (data == null) {
            this.SelectedReservation = null;
        }

        if (this.SelectedReservation != null) {
            if (
                this.SelectedReservation.TritonReservationId ==
                data.TritonReservationId
            ) {
                this.SelectedReservation = null;
            } else {
                this.SelectedReservation = data;
            }
        } else {
            this.SelectedReservation = data;
        }

        this.guestDetail.SetModel(this.SelectedReservation);
    }

    onRowSelected(data: any): void {
        this.onGuestSelected(data);
    }

    onClose(): void {
        this.onGuestSelected(null);
    }

    setAlert(EventType: AlertType): void {
        let req: GuestAlert = new GuestAlert();
        req.GuestId = this.SelectedReservation.GuestId;
        req.ReservationId = this.SelectedReservation.TritonReservationId;
        req.AlertType = EventType;

        this.pmsService.CurrentReservations_SetAlert(req).then((data) => {
            this.FromBaseResponse(data);
            if (this.HasErrors) {
                return;
            }
            if (!data.Result) {
                this.GetMultilingualToast(
                    "ERR.ERR_GUEST_ALERT_DUPLICATE",
                    "error"
                );
                return;
            }
            this.GetMultilingualToast("TS.TS_ALERT_SET_SUCCESS", "success");
        });
    }

    onTagStaff(): void {
        if (
            this.SelectedReservation == null ||
            this.SelectedReservation.TritonReservationId == null
        )
            return;

        this.tagStaff.Open(
            this.SelectedReservation.TritonReservationId,
            EntityCodes.Reservation,
            this.SelectedReservation.PropertyId,
            null
        );
    }

    setDueOutRequestObject(reqObj): void {
        let currentDate = new Date();
        //reqObj.StartDate = currentDate;
        currentDate.setHours(0, 0, 0, 0);
        let utcDate = moment.utc(currentDate);
        reqObj.StartDate = utcDate.toDate();
        reqObj.EndDate = utcDate.add(1, "d").toDate();
        reqObj.ReservationStatus = 2;
    }

    OpenKeyModal(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "lg",
            centered: true,
        };
        this.modalService.open(this.guestKey, ngbModalOptions);
    }

    SearchString = (term$: Observable<string>) =>
        term$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap((term) =>
                this.onSearch(term).pipe(
                    catchError(() => {
                        return of([]);
                    })
                )
            )
        );

    onSearch(term: string): any {
        let result: Array<SearchTextResult> = [];
        if (term == null || term.length == 0) {
            return of(result);
        }

        this.SearchOnEntities.map((ent) => {
            let row = this.SearchOnList(term, ent);
            if (row.ItemCount > 0) result.push(row);
        });

        let rG = new SearchTextResult();
        rG.Entity = EntityCodes.Guest;
        rG.EntityName = "Guests";
        rG.Term = term;
        rG.ItemCount = 0;

        result.push(rG);

        return of(result);
    }

    SearchOnList(term: string, Entity: EntityCodes): SearchTextResult {
        let res = new SearchTextResult();
        res.Entity = Entity;
        res.EntityName = Entity.toString();
        res.Term = term;
        res.ItemCount = 0;

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();
        let count: number = 0;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.Location:
                case EntityCodes.Vip:
                    name = row.Description;
                    break;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    count++;
                }
            }
        }

        res.ItemCount = count;

        return res;
    }

    SearchOnList_GetItems(term: string, Entity: EntityCodes): Array<any> {
        let res = new Array<any>();

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.Vip:
                case EntityCodes.Location:
                    name = row.Description;
                    break;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    if (Entity == EntityCodes.Vip) res.push(row.Code);
                    if (Entity == EntityCodes.Location) res.push(row.Id);
                }
            }
        }

        return res;
    }

    onSearchFilter(sel: NgbTypeaheadSelectItemEvent): void {
        let data: SearchTextResult = sel.item;

        let pCode = this.RequestModel.ReservationStatus;

        this.RequestModel = new CurrentReservationSearch();
        this.RequestModel.SetDefaults();

        this.RequestModel.ReservationStatus = pCode;

        this.SetSearchProperties();

        this.RequestModel.Keyword = null;

        let req = this.RequestModel;

        let res = this.SearchOnList_GetItems(data.Term, data.Entity);

        switch (data.Entity) {
            case EntityCodes.Location:
                req.Locations = res;
                this.FilterRequestModel.Locations = res;
                break;
            case EntityCodes.Vip:
                req.VIPCodes = res;
                this.FilterRequestModel.VIPCodes = res;
                break;
            case EntityCodes.Guest:
                req.Keyword = data.Term;
                break;
        }
        this.SetData();
    }

    SearchFilter_DisplayText(value: SearchTextResult): string {
        if (value == null) return "";

        if (typeof value !== "object") return value;

        return value.Term;
    }

    didChangeDateRange(model: CurrentReservationSearch) {
        this.RequestModel = model;
        this.SetData();
    }

    onGuestDirectory() {
        this.guestSearchPopup.Open(this.RequestModel.PropertyId, true);
    }

    onGuestDetails(row: GuestLookup): void {
        if (row != null) {
            // location description from guest search doesnt have location appended to guest name,
            // which in multi-glitch table shows as guest name (as incident-loc-id and guest location id are same)
            this.SelectedGuests = [row];
            this.onGuestSelected(row);
            this.complainService.increasePopupOpacity = false;
        } else {
            this.SelectedGuests = [];
            this.complainService.increasePopupOpacity = false;
            this.onGuestSelected(null);
        }

    }


}
